import React from "react";
import { Row, Col, Switch } from "antd";
import useTransactionStore from "../../../../stores/useTransactionStore";

/**
 * PAN Customer, NRI Billing, and Credit Sale toggle switches
 * shown at the top of the Contact tab.
 * Used in both AddCustomerDrawer and EditCustomerDrawer.
 */
const CustomerOperationalToggles = ({
  retailCustomerOperationalSettings,
  isPanCustomer,
  setIsPanCustomer,
  panCustomerInfo,
  setPanCustomerInfo,
  isNriBilling,
  setIsNriBilling,
  isCreditSale,
  setIsCreditSale,
  setIsPanUpdateMode,
  clearPanFields,
}) => {
  const hasPanOrNri = retailCustomerOperationalSettings?.enablePanCustomer || retailCustomerOperationalSettings?.enableNriCustomer;

  const panStatusStyle = (realStatus) => {
    if (realStatus === "VALID & OPERATIVE") return { background: "#dcfce7", color: "#166534" };
    if (realStatus === "VALID & INOPERATIVE") return { background: "#fef3c7", color: "#92400e" };
    return { background: "#fee2e2", color: "#991b1b" };
  };

  return (
    <>
      {hasPanOrNri && (
        <div style={{ width: "100%", overflowX: "hidden" }}>
          <Row gutter={16} style={{ marginTop: "20px", marginBottom: "12px" }}>
            {retailCustomerOperationalSettings?.enablePanCustomer && (
              <Col xs={24} sm={24} md={12} lg={12}>
                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                  <div style={{ fontWeight: 600, fontSize: "16px" }}>PAN Customer</div>
                  <Switch
                    checked={isPanCustomer}
                    onChange={(checked) => {
                      setIsPanCustomer(checked);
                      localStorage.setItem("isPanCustomer", String(checked));
                      if (checked) {
                        setIsNriBilling(false);
                        localStorage.setItem("isNriBilling", "false");
                      }
                      if (!checked) {
                        console.log("[PAN Toggle] Disabled — clearing PAN fields and resetting PAN state");
                        setPanCustomerInfo(null);
                        setIsPanUpdateMode(false);
                        clearPanFields();
                      }
                    }}
                  />
                  {panCustomerInfo?.realStatus && (
                    <div
                      style={{
                        padding: "4px 10px",
                        borderRadius: "6px",
                        fontSize: "12px",
                        fontWeight: 600,
                        ...panStatusStyle(panCustomerInfo.realStatus),
                      }}
                    >
                      {panCustomerInfo.realStatus}
                    </div>
                  )}
                </div>
              </Col>
            )}
            {retailCustomerOperationalSettings?.enableNriCustomer && (
              <Col xs={24} sm={24} md={12} lg={12}>
                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                  <div style={{ fontWeight: 600, fontSize: "16px" }}>NRI Billing</div>
                  <Switch
                    checked={isNriBilling}
                    disabled={isPanCustomer}
                    onChange={(checked) => {
                      setIsNriBilling(checked);
                    }}
                  />
                </div>
              </Col>
            )}
          </Row>
        </div>
      )}
      {retailCustomerOperationalSettings?.enableCustomerCredit && (
        <Row gutter={16} style={{ marginTop: "5px", marginBottom: "12px" }}>
          <Col xs={24} sm={24} md={12} lg={12}>
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <div style={{ fontWeight: 600, fontSize: "16px" }}>Credit Sale</div>
              <Switch
                checked={isCreditSale}
                onChange={(checked) => {
                  setIsCreditSale(checked);
                  localStorage.setItem("isCreditSale", String(checked));
                  useTransactionStore.getState().setIsCreditSale(String(checked));
                }}
              />
            </div>
          </Col>
        </Row>
      )}
    </>
  );
};

export default CustomerOperationalToggles;
